@let content = sanitizedContent();

@if (content === null || content === undefined || content === '') {
  <div class="tt-rich-text-view--empty">{{ placeholder | transloco }}</div>
} @else {
  <div [froalaView]="content"></div>
}
